<template>
  <el-footer class="govgr-layout-wrapper gov-no-height" style="height: initial;" role="contentinfo">
    <div class="govgr-full-width-container">
      <div class="gov-text-center-alignment" v-if="showAppInfo">
        <b>Release | Frontend: </b>
        <el-tooltip
          placement="top"
          :open-delay="800"
          effect="light"
          popper-class="release-details-tooltip"
        >
          <div slot="content" class="release-tooltip-content">
            <div class="tooltip-section">
              <div><strong>Release ID:</strong> {{ config.currentRelease.id }}</div>
              <div><strong>Version:</strong> {{ config.currentRelease.version }}</div>
              <div><strong>Type:</strong> {{ config.currentRelease.type }}</div>
              <div class="multi-line-text"><strong>Title:</strong> {{ config.currentRelease.title }}</div>
            </div>
            <div class="tooltip-section">
              <div><strong>Build Details:</strong></div>
              <div class="indent">
                <div>Number: {{ config.currentRelease.build.number }}</div>
                <div>Author: {{ config.currentRelease.build.author }}</div>
                <div>Start Date: {{ config.currentRelease.build.startDate }}</div>
                <div>Build Date: {{ config.currentRelease.build.date || 'N/A' }}</div>
              </div>
            </div>
            <div class="tooltip-section">
              <div><strong>Commits ({{ config.currentRelease.build.commits.length }}):</strong></div>
              <div class="indent">
                <ul class="commits-list">
                  <li v-for="commit in config.currentRelease.build.commits" :key="commit.sha">
                    <span class="commit-type">{{ commit.type }}:</span>
                    {{ commit.message }}
                    <span class="commit-meta">({{ formatSha(commit.sha) }}<span v-if="commit.issues && commit.issues.length > 0">, {{ formatIssues(commit.issues) }}</span>)</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tooltip-footer">
              <a href="#" @click.prevent="openReleaseHistory" class="release-history-link">
                View full release history →
              </a>
            </div>
          </div>
          <span class="app-info-frontend">{{ config.FRONTEND_RELEASE }}, </span>
        </el-tooltip>
        <b>Backend: </b>
        <el-tooltip
          v-if="backendReleaseData"
          placement="top"
          :open-delay="800"
          effect="light"
          popper-class="release-details-tooltip"
        >
          <div slot="content" class="release-tooltip-content">
            <div class="tooltip-section">
              <div><strong>Version:</strong> {{ backendReleaseData.version }}</div>
              <div><strong>Date:</strong> {{ backendReleaseData.date }}</div>
              <div><strong>Issue:</strong> {{ backendReleaseData.issue }}</div>
              <div class="multi-line-text"><strong>Description:</strong> {{ backendReleaseData.description }}</div>
            </div>
            <div class="tooltip-section" v-if="backendReleaseData.changes">
              <div><strong>Changes:</strong></div>
              <div class="indent">
                <div v-for="(changeList, changeType) in backendReleaseData.changes" :key="changeType">
                  <div><strong>{{ formatChangeType(changeType) }}:</strong></div>
                  <ul class="changes-list">
                    <li v-for="(change, index) in changeList" :key="index">{{ change }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <span class="app-info-backend">{{ backendVersion }}</span>
        </el-tooltip>
        <span v-else>{{ backendVersion }}</span>
        <b> URL:</b> {{ config.BASE_URL }} <b>User type:</b> {{ config.USER_TYPE }}
      </div>
      <div class="govgr-footer__meta">
        <div class="govgr-footer__meta-item govgr-footer__meta-item--grow">
          <div class="govgr-footer__content gov-text-valign-center">
            <p class="govgr-footer__licence-description">
              <span @click="toggleAppInfo">© Copyright 2020</span>
               - Υλοποίηση από το <a href="https://www.minedu.gov.gr/" target="_blank" rel="noreferrer noopener" class="govgr-link"> Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού</a>
            </p>
          </div>
          <div class="govgr-footer__content govgr-footer__licence-description gov-text-right-alignment">
            {{ $t('about') }}
            <el-button type="text" @click="toggleComment">
              {{ $t('report') }}
            </el-button>
            <div class="body" v-show="showComment">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 8 }"
                :placeholder="$t('placeholder')"
                v-model="textarea"
                class="message"
              >
              </el-input>
              <el-button
                class="butt"
                type="primary"
                style="float: right"
                @click="sendComment"
              >
                {{ $t('submit') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="govgr-full-width-container">
      <div class="govgr-footer__content">
        <div class="gov-text-center-alignment">
          {{ developmentTeam }}
        </div>
      </div>
    </div>
  </el-footer>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import sharedMethods from './common/sharedMethods.js'
export default {
  props: ['currentUser', 'externalUserId'],
  name: 'Foot',
  mixins: [sharedMethods],
  data() {
    return {
      config: config,
      textarea: '',
      showComment: false,
      showAppInfo: config.DEBUG,
      developmentTeam: `Ομάδα Ανάπτυξης Λογισμικού του τμήματος Β' Διαλειτουργικότητας, 
          Ψηφιακής Σύγκλισης και Διοικητικής Υποστήριξης της 
          Δ/νσης Ηλεκτρονικής Διακυβέρνησης και Απλούστευσης Διαδικασιών του Υ.ΠΑΙ.Θ.Α.`,
      backendVersion: 'Loading...',
      backendReleaseData: null,
    }
  },
  mounted() {
    config.getBackendRelease().then(version => {
      this.backendVersion = version
      this.backendReleaseData = config.getBackendReleaseData()
    })
  },
  computed: {},
  methods: {
    toggleAppInfo(event) {
      if (event.ctrlKey || event.metaKey) {
        this.showAppInfo = !this.showAppInfo
      }
    },
    toggleComment() {
      this.showComment = !this.showComment
    },
    sendComment() {
      if (this.textarea !== '') {
        let requestBody = { comment: this.textarea }
        axios
          .post(
            `${config.BASE_URL}/externalusers/${this.externalUserId}/comment`,
            requestBody
          )
          .then(response => {
            this.backendSuccessMsg(response)
          })
          .catch(err => {
            this.backendErrorNotify(err)
          })
      } else {
        this.$notify.warning({
          title: this.$t('warning'),
          message: this.$t('fill_comment'),
          offset: 100,
        })
      }
    },
    openReleaseHistory() {
      const route = this.$router.resolve({ name: 'ReleaseHistory' })
      window.open(route.href, '_blank')
    },
    formatIssues(issues) {
      if (!issues || issues.length === 0) return ''
      return issues.map(i => `#${i}`).join(', ')
    },
    formatSha(sha) {
      if (!sha) return 'N/A'
      return sha.substring(0, 8)
    },
    formatChangeType(type) {
      return type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
  },
}
</script>
<style scoped>
.app-info-frontend,
.app-info-backend {
  /* No special styling - appears as normal text */
}
.release-tooltip-content {
  font-size: 13px;
  line-height: 1.6;
  max-width: 500px;
}
.tooltip-section {
  margin-bottom: 12px;
}
.tooltip-section:last-child {
  margin-bottom: 0;
}
.tooltip-footer {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #e4e7ed;
  text-align: center;
}
.release-history-link {
  color: #409eff;
  font-size: 12px;
  text-decoration: none;
  font-weight: 500;
}
.release-history-link:hover {
  text-decoration: underline;
}
.tooltip-section .indent {
  margin-left: 16px;
  margin-top: 4px;
}
.multi-line-text {
  white-space: pre-line;
}
.commits-list {
  margin: 4px 0 8px 0;
  padding-left: 12px;
  list-style-type: disc;
}
.commits-list li {
  margin-bottom: 6px;
  line-height: 1.5;
  display: list-item;
  list-style-type: disc;
  list-style-position: outside;
}
.commit-type {
  font-weight: bold;
  color: #409eff;
}
.commit-meta {
  color: #909399;
  font-size: 11px;
  font-family: monospace;
}
.changes-list {
  margin: 4px 0 8px 0;
  padding-left: 20px;
  list-style-type: disc;
}
.changes-list li {
  margin-bottom: 2px;
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
}
.tip {
  width: 0px;
  height: 0px;
  position: absolute;
  background: transparent;
  border: 10px solid #ccc;
}
.dialogbox .body {
  position: relative;
  min-width: 200px;
  height: auto;
  margin: 5px 5px;
  padding: 5px;
  border-radius: 3px;
}
.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: Arial;
  font-size: 14px;
  line-height: 1.5;
  color: #797979;
}
.butt {
  margin: 20px -10px;
}
</style>
<style>
.release-details-tooltip {
  max-width: 600px !important;
}
</style>
